import { Radio as MuiRadio } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: 'border-box',
    padding: 0,
    width: 20,
    height: 20,
    border: `1px solid ${theme.colors.greyCc}`,
    borderRadius: '50%',
    backgroundColor: theme.colors.white,

    '&:hover': {
      backgroundColor: 'unset',
      border: `1px solid ${theme.colors.brandAction}`,
    },

    '&$checked:hover': {
      backgroundColor: theme.colors.brandAction,
    },

    '&$disabled': {
      backgroundColor: theme.colors.greyF7,
      border: `1px solid ${theme.colors.greyE8}`,
    },
  },

  checked: {
    backgroundColor: theme.colors.brandAction,
    border: `1px solid ${theme.colors.brandAction}`,

    '&$disabled': {
      backgroundColor: theme.colors.greyE8,
    },
  },

  disabled: {},

  radioIcon: {
    boxSizing: 'border-box',
    borderRadius: '50%',
    width: 6,
    height: 6,
  },

  checkedRadioIcon: {
    backgroundColor: theme.palette.common.white,
  },
}));

const RadioIcon = ({ checked }) => {
  const classes = useStyles({ checked });
  return <span className={`${classes.radioIcon} ${checked ? classes.checkedRadioIcon : ''}`} />;
};

RadioIcon.propTypes = { checked: PropTypes.bool };
RadioIcon.defaultProps = { checked: false };

function Radio(props) {
  const classes = useStyles();

  return (
    <MuiRadio
      {...props}
      classes={{ root: classes.root, checked: classes.checked, disabled: classes.disabled }}
      color="default"
      disableRipple
      icon={<RadioIcon />}
      checkedIcon={<RadioIcon checked />}
    />
  );
}

export default Radio;
